import { render } from "./EditProjectCard.vue?vue&type=template&id=4be531ee&scoped=true"
import script from "./EditProjectCard.vue?vue&type=script&lang=js"
export * from "./EditProjectCard.vue?vue&type=script&lang=js"

import "./EditProjectCard.vue?vue&type=style&index=0&id=4be531ee&lang=scss&scoped=true"
import "./EditProjectCard.vue?vue&type=style&index=1&id=4be531ee&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4be531ee"]])

export default __exports__